import { render, staticRenderFns } from "./FstCollapse.vue?vue&type=template&id=78a0512a"
import script from "./FstCollapse.vue?vue&type=script&lang=js"
export * from "./FstCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports